import { formatDistanceToNow, format } from 'date-fns';

export const formatPrice = (price, currency = '₹') => {
  if (!price && price !== 0) return 'Free';
  return `${currency}${Number(price).toLocaleString('en-IN')}`;
};

export const formatDate = (date) => {
  if (!date) return '';
  return format(new Date(date), 'dd MMM yyyy');
};

export const timeAgo = (date) => {
  if (!date) return '';
  return formatDistanceToNow(new Date(date), { addSuffix: true });
};

export const truncate = (str, length = 80) => {
  if (!str) return '';
  return str.length > length ? `${str.slice(0, length)}...` : str;
};

export const slugify = (str) =>
  str?.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '') || '';

export const getInitials = (name) => {
  if (!name) return '??';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};

export const trustScoreColor = (score) => {
  if (score >= 80) return 'text-green-600 bg-green-50';
  if (score >= 50) return 'text-yellow-600 bg-yellow-50';
  return 'text-red-600 bg-red-50';
};

export const trustScoreLabel = (score) => {
  if (score >= 90) return 'Highly Trusted';
  if (score >= 75) return 'Trusted';
  if (score >= 50) return 'Verified';
  if (score >= 25) return 'New Seller';
  return 'Unverified';
};

export const CATEGORIES = [
  { id: 'electronics', label: 'Electronics', icon: '📱', color: 'bg-blue-50 text-blue-600' },
  { id: 'vehicles', label: 'Vehicles', icon: '🚗', color: 'bg-red-50 text-red-600' },
  { id: 'property', label: 'Property', icon: '🏠', color: 'bg-green-50 text-green-600' },
  { id: 'fashion', label: 'Fashion', icon: '👗', color: 'bg-pink-50 text-pink-600' },
  { id: 'furniture', label: 'Furniture', icon: '🛋️', color: 'bg-yellow-50 text-yellow-600' },
  { id: 'sports', label: 'Sports', icon: '⚽', color: 'bg-orange-50 text-orange-600' },
  { id: 'books', label: 'Books', icon: '📚', color: 'bg-indigo-50 text-indigo-600' },
  { id: 'pets', label: 'Pets', icon: '🐾', color: 'bg-purple-50 text-purple-600' },
  { id: 'agriculture', label: 'Agriculture', icon: '🌾', color: 'bg-lime-50 text-lime-600' },
  { id: 'services', label: 'Services', icon: '🛠️', color: 'bg-cyan-50 text-cyan-600' },
  { id: 'jobs', label: 'Jobs', icon: '💼', color: 'bg-teal-50 text-teal-600' },
  { id: 'others', label: 'Others', icon: '📦', color: 'bg-gray-50 text-gray-600' },
];

export const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest First' },
  { value: 'oldest', label: 'Oldest First' },
  { value: 'price_asc', label: 'Price: Low to High' },
  { value: 'price_desc', label: 'Price: High to Low' },
  { value: 'popular', label: 'Most Popular' },
];

export const CONDITIONS = ['New', 'Like New', 'Good', 'Fair', 'Poor'];

export const SERVICE_CONDITIONS = ['Experienced', 'Fresher', 'Professional'];

export const SERVICES = [
  { id: 'laundry', label: 'Laundry', icon: '👕' },
  { id: 'housekeeping', label: 'Housekeeping', icon: '🧹' },
  { id: 'furniture_cleaning', label: 'Furniture Cleaning', icon: '🛋️' },
  { id: 'ac_servicing', label: 'AC Servicing', icon: '❄️' },
  { id: 'car_servicing', label: 'Car Servicing', icon: '🔧' },
  { id: 'vehicle_supply', label: 'Vehicle Supply', icon: '🚚' },
  { id: 'rent', label: 'Rent', icon: '🏘️' },
  { id: 'tutoring', label: 'Tutoring', icon: '📖' },
  { id: 'plumbing', label: 'Plumbing', icon: '🔩' },
  { id: 'electrical', label: 'Electrical Work', icon: '⚡' },
  { id: 'painting', label: 'Painting', icon: '🎨' },
  { id: 'cooking', label: 'Cooking / Catering', icon: '🍳' },
  { id: 'security', label: 'Security Guard', icon: '🛡️' },
  { id: 'driver', label: 'Driver / Chauffeur', icon: '🚗' },
  { id: 'other_service', label: 'Other Services', icon: '🛠️' },
];

export const INDIAN_STATES = [
  'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
  'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
  'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
  'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
  'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
  'Delhi', 'Mumbai', 'Bangalore', 'Chennai', 'Hyderabad', 'Pune', 'Kolkata',
];

export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

export const generateId = () => Math.random().toString(36).substr(2, 9);

export const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
export const isValidPhone = (phone) => /^[6-9]\d{9}$/.test(phone);
